import React, { useState } from 'react';
import { Tooltip, Button, Pagination } from 'antd';
import { Edit } from '@material-ui/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import SponsorsFormModal from 'components/Dashboard/WorldCup/Sponsors/SponsorsFormModal';
import { Sponsors } from 'core/worldCup/sponsors/types';
import { Img } from 'react-image';
import { getImageLink } from 'utilities/common';
import { PAGE_SIZE_OPTIONS } from 'utilities/constants';

type SponsorsTableType = {
  sponsorsData: Array<Sponsors | null>;
  total: number;
  current: number;
  pageSize: number;
  onChangePage: (page: number, size: number) => void;
  setCurrent: (e: number) => void;
  setPageSize: (e: number) => void;
};

const SponsorsTable: React.FC<SponsorsTableType> = ({
  sponsorsData,
  total,
  current,
  pageSize,
  onChangePage,
  setCurrent,
  setPageSize,
}) => {
  const [isShowDetailModal, setShowDetailModal] = useState(false);
  const [sponsorInfo, setSponsorInfo] = useState<Sponsors | null>(null);
  const intl = useIntl();

  const handleChangePage = (page: number, size: number) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage(page, size);
  };

  const handleShowSizeChange = (c: number, s: number) => {
    handleChangePage(1, s);
  };

  const renderSponsorsImage = (item: Sponsors | null) => {
    if (item?.logo) {
      return <Img src={getImageLink(item.logo)} alt="sponsor" />;
    } else {
      return <div className="photo_name">{`${item?.name ? item.name.charAt(0) : ''}`}</div>;
    }
  };

  return (
    <div className="sponsors_table_layout" id="sponsors_table_layout">
      <div className="table_header">
        <div className="id">
          <FormattedMessage id="ID" />
        </div>
        <div className="sponsors_photo" />
        <div className="name">
          <FormattedMessage id="Name" />
        </div>
        <div className="status">
          <FormattedMessage id="Status" />
        </div>
        <div className="actions">
          <FormattedMessage id="Actions" />
        </div>
      </div>
      <div>
        <div className="table_content" id="sponsors_table_content">
          {Array.isArray(sponsorsData) &&
            sponsorsData.map((item, index) => (
              <div className={`table_item type_state_${item?.isActive}`} key={index} id={`sponsor_item_${item?.id}`}>
                <div className="id">
                  <p>{item?.id}</p>
                </div>
                <div className="sponsors_photo">
                  <div className="photo_wrapper">{renderSponsorsImage(item)} </div>
                </div>
                <div className="name">
                  <p>{item?.name}</p>
                </div>
                <div className="status">
                  <span className={`status_badge ${item?.isActive ? 'active' : 'inactive'}`}>
                    {item?.isActive ? 'Activo' : 'Inactivo'}
                  </span>
                </div>
                <div className="actions">
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: 'Edit sponsor' })}
                    id="sponsor_edit_tooltip"
                  >
                    <Button
                      className="edit_btn"
                      onClick={() => {
                        setSponsorInfo(item);
                        setShowDetailModal(true);
                      }}
                      id="sponsor_edit_btn"
                    >
                      <Edit />
                    </Button>
                  </Tooltip>
                </div>
              </div>
            ))}
        </div>
        <div className="pagination_wrapper">
          <Pagination
            showSizeChanger
            defaultCurrent={1}
            defaultPageSize={10}
            current={current}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            total={total}
            onChange={handleChangePage}
            onShowSizeChange={handleShowSizeChange}
          />
          <div className="total">Resultados: {total}</div>
        </div>
      </div>
      <SponsorsFormModal
        mode="modal"
        isOpenModal={isShowDetailModal}
        onCloseModal={() => setShowDetailModal(false)}
        onSaveSuccess={() => onChangePage(current, pageSize)}
        sponsor={sponsorInfo}
      />
    </div>
  );
};

export default SponsorsTable;
